import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { validateProps } from '../../../../utils/propValidator';

const propRules = {
  title: { type: 'string', required: true },
  variant: { oneOf: ['title', 'subtitle'] },
  meta: { type: 'node' },
  action: { type: 'node' },
};

export default function SectionTitle(props: any) {
  validateProps(props as Record<string, unknown>, propRules, 'SectionTitle');

  const { title, meta, action, variant = 'title' } = props;

  return (
    <Box sx={{ display: 'grid', gridTemplateColumns: 'auto minmax(0, 1fr) auto', alignItems: 'center', gap: 1 }}>
      {/* The title column sizes to its text and never wraps, so headings that carry a job
          code stay on one line even in a narrow dialog; `meta` takes whatever is left. */}
      <Typography
        variant='subtitle1'
        fontSize='1rem'
        component={variant === 'title' ? 'h2' : 'h3'}
        sx={{ whiteSpace: 'nowrap' }}
      >
        {title}
      </Typography>
      <Box sx={{ justifySelf: 'center', minWidth: 0 }}>{meta}</Box>
      <Box sx={{ justifySelf: 'end' }}>{action}</Box>
    </Box>
  );
}
